import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaEyeSlash, FaSpinner } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import Notification from "../../components/Notification";
import background from "../../image/fondo_nubes.jpg";

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // Manejo del error
  const { handlePasswordReset, userCorreo } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmNewPassword) {
      setError("Las contraseñas no coinciden"); // Mostrar error
      return;
    }

    setLoading(true);
    setError(""); // Limpiar error previo si existe

    try {
      await handlePasswordReset(userCorreo, formData.newPassword);
    } catch (error) {
      setError("Error al restablecer la contraseña");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen text-white p-4">
      {/* Imagen de fondo con opacidad */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70 bg-gray/50"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      {/* Overlay oscuro con opacidad */}
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative w-full max-w-md bg-main-bg-sidebar p-8 rounded-2xl shadow-lg">
        <h2 className="text-3xl mb-4 font-bold text-center">
          Restablecer Contraseña
        </h2>
        <p className="text-gray-600 mb-2 text-center font-medium">
          Correo: {userCorreo}
        </p>
        <form onSubmit={handleSubmit}>
          {/* Contraseña */}
          <div className="relative mb-6 mt-6">
            <input
              type={showPassword.newPassword ? "text" : "password"}
              name="newPassword"
              placeholder="Nueva Contraseña"
              value={formData.newPassword}
              onChange={handleChange}
              className="w-full bg-transparent placeholder:text-xs md:placeholder:text-base border border-white/40 rounded-full px-4 py-3 text-white placeholder-gray outline-none focus:border-blue-300"
              required
            />
            {showPassword.newPassword ? (
              <FaEyeSlash
                size={21}
                className="absolute top-1/2 right-[20px] transform -translate-y-1/2 text-white text-lg cursor-pointer"
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    newPassword: !prev.newPassword,
                  }))
                }
              />
            ) : (
              <IoEyeSharp
                size={21}
                className="absolute top-1/2 right-[20px] transform -translate-y-1/2 text-white text-lg cursor-pointer"
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    newPassword: !prev.newPassword,
                  }))
                }
              />
            )}
          </div>

          {/* Confirmar Contraseña */}
          <div className="relative mb-6 mt-6">
            <input
              type={showPassword.confirmNewPassword ? "text" : "password"}
              name="confirmNewPassword"
              placeholder="Confirmar Nueva Contraseña"
              value={formData.confirmNewPassword}
              onChange={handleChange}
              className="w-full bg-transparent placeholder:text-xs md:placeholder:text-base border border-white/40 rounded-full px-4 py-3 text-white placeholder-gray outline-none focus:border-blue-300"
              required
            />
            {showPassword.confirmNewPassword ? (
              <FaEyeSlash
                size={21}
                className="absolute top-1/2 right-[20px] transform -translate-y-1/2 text-white text-lg cursor-pointer"
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    confirmNewPassword: !prev.confirmNewPassword,
                  }))
                }
              />
            ) : (
              <IoEyeSharp
                size={21}
                className="absolute top-1/2 right-[20px] transform -translate-y-1/2 text-white text-lg cursor-pointer"
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    confirmNewPassword: !prev.confirmNewPassword,
                  }))
                }
              />
            )}
          </div>
          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="w-[20rem] bg-white text-black font-semibold p-3 rounded-full hover:bg-slate-200 transition"
              disabled={loading}
            >
              {loading ? (
                <FaSpinner className="animate-spin mr-2" />
              ) : (
                "Restablecer Contraseña"
              )}
            </button>
          </div>
        </form>

        {error && (
          <Notification
            type="error"
            message={error}
            onClose={() => setError("")}
          />
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
